import { Jane, OrderStatus, OrderStatusEnum } from 'types/graphql';
import { LocationOptionType } from 'components/LocationFilterInput/LocationFilterInput.types';

type IGetIsJaneCommunityMismatch = {
  acceptedBySharedTeamMember: Nullable<boolean>;
  status: OrderStatus;
  currentlySelectedLocation: LocationOptionType;
  isMultiLocationCallOutFeatureEnabled: boolean;
  isMultiLocationSchedulingFeatureEnabled: boolean;
  isMultiLocationTieringFeatureEnabled: boolean;
  mainJane: Jane | null;
};
export const getIsJaneCommunityMismatch = ({
  acceptedBySharedTeamMember,
  status,
  mainJane = null,
  currentlySelectedLocation,
  isMultiLocationCallOutFeatureEnabled = false,
  isMultiLocationSchedulingFeatureEnabled = false,
  isMultiLocationTieringFeatureEnabled = false,
}: IGetIsJaneCommunityMismatch): boolean => {
  if (isMultiLocationCallOutFeatureEnabled || isMultiLocationTieringFeatureEnabled)
    return (
      !!mainJane &&
      !mainJane?.agencyCommunity &&
      `${mainJane?.primaryCommunity?.id}` !== currentlySelectedLocation?.value?.toString()
    );
  else
    return (
      isMultiLocationSchedulingFeatureEnabled &&
      !!mainJane &&
      !mainJane?.agencyCommunity &&
      (!acceptedBySharedTeamMember || status.value === OrderStatusEnum.assigned) &&
      `${mainJane?.primaryCommunity?.id}` !== currentlySelectedLocation?.value?.toString()
    );
};
